$(window).on('socialLikesLoaded', function() {
    $('.social-likes-inline-js').socialLikes({
        counters: false
    });
});
